import _ from 'underscore';

import Evaluation from 'pages/open-course/assessment/models/exam/evaluation';

// TODO: Slowly migrate off Backbone to something like this. This is an incomplete type definition which needs to be filled.
// Reverse-engineered from SubmissionPartRow.props.part.toJSON(),
export type SubmissionPartEvaluationType = {
  gradingProgress: 'failed';
  isGridV2: boolean;
  isOptional: boolean;
  isSubmitted: boolean;
  maxScore: number;
  order: number;
  partId: string;
  passingFraction: number;
  score?: number;
  sessionId: string;
  title: string;
  typeName: 'grid';
};

const SubmissionPartEvaluation = Evaluation.extend({
  defaults: _({}).extend(Evaluation.prototype.defaults, {
    partId: null,
  }),
});

export default SubmissionPartEvaluation;
